/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S2_Card2_BodyInputs */

const tr_cerez_s2_card2_body = /** @type {(inputs: Cerez_S2_Card2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şu an kullanılmıyor. Uygulama hatalarını izleyen Sentry, zorunlu hizmet olarak 5. bölümde açıklanmıştır. İleride analitik bir araç eklenmesi halinde ayrıca rıza istenir.`)
};

const en_cerez_s2_card2_body = /** @type {(inputs: Cerez_S2_Card2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currently not in use. Sentry, which tracks application errors, is described as a necessary service in section 5. If an analytics tool is added in the future, separate consent will be requested.`)
};

const de_cerez_s2_card2_body = /** @type {(inputs: Cerez_S2_Card2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derzeit nicht in Gebrauch. Sentry, das Anwendungsfehler erfasst, ist in Abschnitt 5 als notwendiger Dienst beschrieben. Kommt künftig ein Analysewerkzeug hinzu, wird gesondert um Zustimmung gebeten.`)
};

const ru_cerez_s2_card2_body = /** @type {(inputs: Cerez_S2_Card2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В настоящее время не используются. Sentry, отслеживающий ошибки приложения, описан как необходимый сервис в разделе 5. Если в будущем появится инструмент аналитики, будет запрошено отдельное согласие.`)
};

/**
* | output |
* | --- |
* | "Currently not in use. Sentry, which tracks application errors, is described as a necessary service in section 5. If an analytics tool is added in the future,..." |
*
* @param {Cerez_S2_Card2_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s2_card2_body = /** @type {((inputs?: Cerez_S2_Card2_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S2_Card2_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s2_card2_body(inputs)
	if (locale === "de") return de_cerez_s2_card2_body(inputs)
	if (locale === "ru") return ru_cerez_s2_card2_body(inputs)
	return tr_cerez_s2_card2_body(inputs)
});